export default __webpack_public_path__ + "static/media/wjxxd.2d155190.png";